import { getUserTimezone } from './timezone';

const pad2 = (value) => String(value).padStart(2, '0');

export const parseStoredUtcDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : new Date(value.getTime());
  }

  const raw = String(value).trim();
  if (!raw) return null;
  const normalized = raw.includes('T') ? raw : raw.replace(' ', 'T');
  const hasTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(normalized);
  const parsed = new Date(hasTimezone ? normalized : `${normalized}Z`);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const toConfiguredTimezoneDate = (value, timezoneOffset = getUserTimezone()) => {
  const utcDate = parseStoredUtcDate(value);
  if (!utcDate) return null;
  return new Date(utcDate.getTime() + Number(timezoneOffset || 0) * 60 * 60 * 1000);
};

const sameUtcCalendarDay = (left, right) => (
  left.getUTCFullYear() === right.getUTCFullYear()
  && left.getUTCMonth() === right.getUTCMonth()
  && left.getUTCDate() === right.getUTCDate()
);

export const formatTransactionMoment = (
  value,
  nowValue = new Date(),
  timezoneOffset = getUserTimezone()
) => {
  const localDate = toConfiguredTimezoneDate(value, timezoneOffset);
  const nowUtc = parseStoredUtcDate(nowValue);
  if (!localDate || !nowUtc) return 'Дата не указана';

  const localNow = new Date(nowUtc.getTime() + Number(timezoneOffset || 0) * 60 * 60 * 1000);
  const yesterday = new Date(localNow.getTime());
  yesterday.setUTCDate(yesterday.getUTCDate() - 1);
  const time = `${pad2(localDate.getUTCHours())}:${pad2(localDate.getUTCMinutes())}`;

  if (sameUtcCalendarDay(localDate, localNow)) return `Сегодня, ${time}`;
  if (sameUtcCalendarDay(localDate, yesterday)) return `Вчера, ${time}`;
  return `${pad2(localDate.getUTCDate())}.${pad2(localDate.getUTCMonth() + 1)}, ${time}`;
};

export const formatTransactionFullMoment = (value, timezoneOffset = getUserTimezone()) => {
  const localDate = toConfiguredTimezoneDate(value, timezoneOffset);
  if (!localDate) return 'Дата не указана';
  return [
    `${pad2(localDate.getUTCDate())}.${pad2(localDate.getUTCMonth() + 1)}.${localDate.getUTCFullYear()}`,
    `${pad2(localDate.getUTCHours())}:${pad2(localDate.getUTCMinutes())}:${pad2(localDate.getUTCSeconds())}`,
  ].join(', ');
};

export const formatTransactionFilterBoundary = (
  value,
  endOfDay = false,
  timezoneOffset = getUserTimezone()
) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || '').trim());
  if (!match) return undefined;

  const [, year, month, day] = match;
  const localHour = endOfDay ? 23 : 0;
  const localMinute = endOfDay ? 59 : 0;
  const localSecond = endOfDay ? 59 : 0;
  const localMillisecond = endOfDay ? 999 : 0;
  const utcMilliseconds = Date.UTC(
    Number(year),
    Number(month) - 1,
    Number(day),
    localHour - Number(timezoneOffset || 0),
    localMinute,
    localSecond,
    localMillisecond
  );
  return new Date(utcMilliseconds).toISOString();
};

export const transactionTimestampMs = (value) => parseStoredUtcDate(value)?.getTime() || 0;
